import React from 'react';
import styled from 'styled-components';

import Button from '../../components/button';
import { Cross } from '../../assets/icons';
import { Heading } from '../../components/typography';

export default function CardQueryErrorComponent({ close }: { close(): void }) {
  return (
    <>
      <Cross />
      <MessageContainer size="lg" as="div">
        Unable to load rewards card
      </MessageContainer>
      <Button modifiers="secondaryRound" onClick={() => close()}>
        Close
      </Button>
    </>
  );
}

const MessageContainer = styled(Heading)`
  padding: 2.4rem 3.75rem;
`;
